import { useCallback, useState } from 'react';
type PropsT = {
  mouseCoords: {
    x: number;
    y: number;
  };
  center: [number, number];
};
const useRotation = () => {
  const [angle, setAngle] = useState(0);
  const calculateRotationAngle = useCallback((x, y, centerCoords) => {
    if (x !== 0 && y !== 0) {
      const boxCenter = {
        x: centerCoords[0],
        y: centerCoords[1]
      };
      // eslint-disable-next-line react-hooks/immutability
      const rotationAngle = getRadians(x, y, boxCenter);
      setAngle(rotationAngle);
    } else {
      setAngle(0);
    }
  }, []);
  const setRotationAngle = ({
    mouseCoords,
    center
  }: PropsT) => {
    calculateRotationAngle(mouseCoords.x, mouseCoords.y, center);
  };
  const getRadians = (x: number, y: number, boxCenter: {
    x: number;
    y: number;
  }) => {
    let radians = Math.atan2(y - boxCenter.y, x - boxCenter.x);
    // adding PI/2 to rotate exactly with mouse pos
    return radians + Math.PI / 2;
  };
  return {
    rotationAngle: angle,
    setRotationAngle
  };
};
export default useRotation;